(function () {
    'use strict';

    /**
    * @memberof app
    * @ngdoc controller
    * @name UserController
    * @description
    * This is main controller
    **/

    angular
        .module('app')
        .controller('UserController', UserController);

    UserController.$inject = ['$scope', 'UserService', '$window', '$cookies', 'ColaboracionService', '$filter', '$timeout'];


    function UserController($scope, UserService, $window, $cookies, ColaboracionService, $filter, $timeout) {

        var vm = this;
        vm.username = "";
        vm.recuperarclave = false;
        vm.msgerror = false;
        vm.msgerrorlogin = false;
        vm.msgemail = false;
        vm.errors = false;
        vm.reseteado = false;
        vm.loading = false;
        vm.usersDelegados = [];
        vm.respuestasUsuario = [];
        vm.colaboraciones = [];
        vm.progreso_colaboracion = [];
        vm.sesionCookie = true;
        vm.sesionCookieactive = $cookies.get('sesionCookie');
        vm.delegadoActivo = false;
        vm.delegadosactivos = true;
        vm.delegadosproceso = true;
        vm.estadosColaboracion = {};
        vm.startDate = null;
        vm.endDate = null;
        vm.dateRange = false;
        vm.colaboracionesepmty = false;
        vm.colaboracionescompletadas = 0;
        vm.fechascoinciden = false;

        vm.changepassword = function (form) {
            vm.msgerror = false;
            UserService.Changepassword(vm).then(function (data) {
                vm.finalpass = data.finalpass;
                vm.msgerrorcontra = data.msgerrorcontra;
                vm.msgerror = data.msgerror;
				vm.msgerrorlogin = data.msgerrorlogin;
				if (vm.finalpass) {
					$timeout(function () {
						window.location.href = "/es/scientia";
					}, 6000);
				}
			
            });
        };

        vm.recovery = function (form) {
            vm.msgerror = false;
            vm.msgemail = false;
            vm.loading = true;
            UserService.Recuperarpassword(vm).then(function (data) {
                vm.msgerror = data.msgerror;
                vm.msgemail = data.msgemail;
                vm.username = data.username;
                vm.msgcorrecto = data.msgcorrecto;
                if (vm.msgemail == undefined && vm.msgcorrecto == undefined && vm.msgerror == undefined) {
                    vm.msgerrorlogin = true;
                }
                vm.loading = false;
            });
        };

        vm.delegados = function (init) {
            UserService.Delegados(vm.filtros, function (data) {
                vm.usersDelegados = data.usersDelegados || [];
                vm.delegaos = data.delegaos;
                vm.delegado = data.delegado;
                // console.log(vm.delegaos);
                // console.log("antes", vm.usersDelegados);

                angular.forEach(data.usersDelegados, function (col, key) {
                        ColaboracionService.getColaboraciones(col.id, vm.startDate, vm.endDate).then(function (data) {
                            vm.usersDelegados[key]["colaboraciones"] = data;
                        });
                });
            });
        }

        vm.userIdColaboraciones = function (delegado) {
            movilDelegados();
            ColaboracionService.getColaboraciones(delegado.id, vm.startDate, vm.endDate).then(function (data) {
                vm.delegadoActivo = delegado;
                vm.colaboraciones = data.colaboraciones || [];

				console.log(vm.colaboraciones)
                vm.getRespuestasByUserDel(delegado.id);
            });
        }

        // $scope.$on('datepickerCreate', function (event, data) {
        //     vm.startDate = data.startDate.format("DD/MM/YYYY");
        //     vm.endDate = data.endDate.format("DD/MM/YYYY");
        //     // console.log('Start Date dEFAULT:', vm.startDate);
        //     // console.log('End Date dEFAULT:', vm.endDate);
        //     vm.delegados();
        // });

        // $scope.$on('dateRangeChanged', function (event, data) {
        //     vm.startDate = data.startDate;
        //     vm.endDate = data.endDate;
        //     // console.log('Start Date:', vm.startDate);
        //     // console.log('End Date:', vm.endDate);
        //     // console.log(vm.usersDelegados);
        //     // console.log(data);
        //     $scope.$apply();
        //     angular.forEach(vm.usersDelegados, function (col, key) {
        //             ColaboracionService.getColaboraciones(col.id, vm.startDate, vm.endDate).then(function (data) {
        //                 vm.usersDelegados[key]["colaboraciones"] = data;
        //             });
        //     });

        // });

        vm.filtrarDelegados = function (delegado) {
            var activo = vm.delegadosactivos && delegado.contrato && delegado.datos_user != false;

            if (activo && vm.delegadosactivos) {
                return true;
            } else if ((vm.delegadosproceso && !delegado.contrato && delegado.datos_user == false) || (vm.delegadosproceso && delegado.contrato && delegado.datos_user == false)) {
                return true;
            } else {
                return false;
            }
        };

		vm.toDate = function (str) {
			if (!str || str === "" || str === "undefined") return null;
			if (str instanceof Date) return str;
			var d = moment(str, ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD", "DD/MM/YYYY", "D/M/YYYY"]);
			return d.isValid() ? d.toDate() : null;
		};

		vm.ordenarTareasUsuario = function (col) {
			var fText = (col && col.fecha_completada) ? col.fecha_completada : null;
			var d = vm.toDate(fText);
			if (!d) {
				// Tareas PENDIENTES: Ordenar cronológicamente por fecha límite de realización (fecha_final).
				//Las más nuevas al principio.
				var d2 = vm.toDate(col && col.fecha_final);
				//return d2 ? d2.getTime() : 1;
				return d2 ? -d2.getTime() : 1;

			}
			// Tareas COMPLETADAS: Ordenar por fecha de resolución (fecha_completada).
			// El timestamp negativo invierte el orden a descendente (mostrando arriba las más recientes).
			return -d.getTime();
		};
		
        vm.filtrarColaboraciones = function (colaboracion) {
            if (!vm.estadosColaboracion || !vm.estadosColaboracion[colaboracion.estado.id]) {
                return false;
            }

            vm.colaboracionesepmty = false;
            return true;
        };

        vm.getClaseEstado = function (estado_id) {
            var diccionario = {
                131: 'completa',
                132: 'pendiente',
                133: 'pendiente-firma limite'
            };
            diccionario[vm.estadoEnRevision] = 'pendiente';
            diccionario[vm.estadoCaducada] = 'pendiente-firma limite';
            return diccionario[estado_id] || 'pendiente';
        };


        vm.filtrarDelegadosbyname = function (delegado) {

            if (vm.searchName && vm.searchName.trim() !== '') {
                var nombre = delegado.name.toLowerCase();
                var filtro = vm.searchName.toLowerCase();

                nombre = nombre.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                filtro = filtro.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

                return nombre.includes(filtro);
            }

            return true;
        };



        vm.getRespuestasByUserDel = function (user_id) {
            ColaboracionService.getRespuestasByUser(user_id).then(function (resp) {
                // console.log("hola",resp);
                if (resp.status == 200) {
                    vm.respuestasUsuario = resp.respuestas;
                    vm.progreso_colaboracion = resp.progreso;
                    // console.log(vm.respuestasUsuario);
                    // console.log(vm.progreso_colaboracion);
                }

            });
        }

        vm.getProceso = function (colaboracion_id) {
            var b = 0;
            angular.forEach(vm.progreso_colaboracion, function (value, key) {
                if (key == colaboracion_id)
                    b = value;
            });
            return b;
        }

        vm.login = function () {
            vm.errors = false;
            UserService.Login(vm).then(function (data) {
                vm.errors = data.errors;
                vm.msgcorrecto = data.msgcorrecto;
                vm.msgemail = data.msgemail;

                if (vm.msgemail == undefined && vm.msgcorrecto == undefined && vm.errors == undefined) {
                    vm.msgerrorlogin = true;
                }

                if (data.slugRegistro) {
                    window.location = data.slugRegistro;
                    window.open(data.slugRegistro, '_system');
                }

            });
        };

        vm.reset = function (form) {
            vm.username = "";
            vm.password = "";
            vm.reseteado = true;
            form.$setPristine();
            // vm.staticClass.pop('is-invalid');
            //console.log(form);

        }

        var sesionModal

        vm.SetCookies = function (cookieNochecked) {
            $cookies.put('sesionCookie', vm.sesionCookie);
            if (!cookieNochecked) {
                vm.ClearCookies();
            }
        };

        vm.ClearCookies = function () {
            $cookies.remove('sesionCookie');

        };

        vm.closeSesionModal = function () {
            if (vm.sesionCookieactive == undefined || vm.sesionCookieactive == false) {
                sesionModal = new bootstrap.Modal(document.getElementById('modalsesion'), {
                    keyboard: false
                });
                sesionModal.show();
            }
        }

    }
})();